@let employee = result();

<soft-search-result-item
  [tone]="statusTone(employee)"
  [title]="employee.lstfix.vorname + ' ' + employee.lstfix.zuname"
  [meta]="meta(employee)"
  (click)="openMitarbeiterDetailView(employee)"
>
  <span
    searchResultLeading
    class="inline-block w-2.5 h-2.5 rounded-full"
    [ngClass]="{
      'bg-success-500': employee.status === 'A',
      'bg-warning-500': employee.status === 'E',
      'bg-danger-500': employee.status === 'U',
      'bg-gray-400':
        employee.status !== 'A' && employee.status !== 'E' && employee.status !== 'U',
    }"
  ></span>
</soft-search-result-item>
